var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('embed',{staticClass:"pdf-visor",attrs:{"src":_vm.urlFile || _vm.filePath}})])}
var staticRenderFns = []

export { render, staticRenderFns }